module.exports = __webpack_public_path__ + "static/img/default_ dynamic.02bdc2b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/defaultTip/img/default_ dynamic.jpg
// module id = pFnq
// module chunks = 27